module.exports = __webpack_public_path__ + "pic/44.39fb990a.png";